import { Toast } from '@easyvaas/js-components';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import SmallText from 'src/components/SmallText';
import { useClosePopup } from '../../hooks/useClosePopup';
import { imagesV3Data, transformPiece } from '../../services';
import {
  materialItemSelector,
  pieceItemLogoSelector,
  pieceItemSelector
} from '../../store/selector';
import { imagePopupState } from '../../store/state';
import ImageOperationPopup from '../ImageOpreationPopup';
import NumberInput from '../NumberInput';
import styles from './index.module.scss';
const TransformPopup = () => {
  const { target, visible } = useRecoilValue(imagePopupState('transform'));
  const base = useRecoilValue(pieceItemSelector(0));
  const item = useRecoilValue(materialItemSelector(target));
  const [number, setNumber] = useState('0');
  const [tab, setTab] = useState<1 | 2>(1);
  const pieceLogo = useRecoilValue(pieceItemLogoSelector(0));
  const ecoinLogo = useRecoilValue(pieceItemLogoSelector(100));
  const close = useClosePopup();
  const onClick = async () => {
    if (!item) return;
    try {
      Toast.loading('转换中');
      await transformPiece({
        toolId: item.toolId,
        number: Number(number),
        type: tab
      });
      await imagesV3Data.refresh({});
      Toast('转换成功');
      close('transform');
    } catch ({ message }) {
      Toast(message);
    }
  };
  useEffect(() => {
    if (visible) {
      setNumber('1');
      setTab(1);
    }
  }, [visible]);
  if (!base || !item) return null;

  return (
    <ImageOperationPopup
      title="碎片转换"
      type="transform"
      className={styles.container}
      onClick={onClick}
      confirmText="转换"
    >
      <div className={styles.tabbar}>
        <div
          className={classNames(styles.item, tab === 1 && styles.active)}
          onClick={() => setTab(1)}
        >
          普通转换
        </div>
        <div
          className={classNames(styles.item, tab === 2 && styles.active)}
          onClick={() => setTab(2)}
        >
          高级转换
        </div>
      </div>
      <div className={styles.items}>
        <div className={styles.item}>
          <div
            className={styles.logo}
            style={{ backgroundImage: `url(${item.logo})` }}
          />
          <div className={styles.name}>{item.title}</div>
        </div>
        <div className={styles.transform}>
          <SmallText fontSize={20} className={styles.text} inline>
            转换
          </SmallText>
        </div>
        <div className={styles.item}>
          <div
            className={styles.logo}
            style={{ backgroundImage: `url(${base.logo})` }}
          />
          <div className={styles.name}>{base.title}</div>
        </div>
      </div>
      <div className={styles.cell}>
        <div className={styles.label}>转换数量</div>
        <NumberInput value={number} onChange={setNumber} max={item.number} />
      </div>
      <div className={styles.cell}>
        <div className={styles.label}>获得碎片</div>
        <div
          className={styles.piece}
          style={{ backgroundImage: `url(${pieceLogo})` }}
        />
        <div className={styles.value}>
          {Math.floor(Number(number) / (tab === 1 ? 2 : 1))}
        </div>
      </div>
      <div className={styles.cell}>
        <div className={styles.label}>消耗金币</div>
        <div
          className={styles.piece}
          style={{ backgroundImage: `url(${ecoinLogo})` }}
        />
        <div className={styles.value}>
          {tab === 1 ? 0 : Number(number) * 200}
        </div>
      </div>
    </ImageOperationPopup>
  );
};

export default React.memo(TransformPopup);
